<template>
  <v-card :loading="loading">
    <v-card-title> Add Technical Skills </v-card-title>
    <v-form ref="frmMain" lazy-validation>
      <v-card-text>
        <v-row>
          <v-col cols="12"
            ><InfoBox
              title="Add your technical Skills, then select your favourite skills from the list. If you don’t see your skill listed, you can submit it manually"
          /></v-col>
          <v-col cols="12">
            <v-btn class="primary_btn w-100" prepend-icon="mdi-plus" @click="showAddSkill">Add Skill</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="teammemberSkillList && teammemberSkillList.length">
          <v-col cols="12"><h4>Select your Favourite Skills (Choose up to 5)</h4></v-col>
          <v-col cols="12" v-for="(item, index) in teammemberSkillList" :key="'row_' + index">
            <SkillItem
              :skill="item"
              @edit="edit(item)"
              @remove="remove(item)"
              @changeSkillStatus="changeSkillStatus(item)"
              :teammemberSkillList="teammemberSkillList"
              :skillList="skillList"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-form>
    <v-dialog v-model="showJobRequestConfirm" max-width="500" @keydown.esc="showJobRequestConfirm = false" persistent>
      <confirm-dialog
        :loading="sendReqeustLoadingProgress"
        :message="confirmModel"
        showInput
        inputLable="Job Title"
        @confirm="confirmSendJobRequest"
        @cancel="cancelSending"
      ></confirm-dialog>
    </v-dialog>
    <v-dialog v-if="showAddOrEdit" v-model="showAddOrEdit" max-width="1000" @keydown.esc="closeEdit()" persistent>
      <AddOrEditSkill
        :isHiringmanager="isHiringmanager"
        @skillCertificateChanged="skillCertificateChanged"
        @saveSkill="saveSkill"
        @addSkill="addSkill"
        :uploadedCertificateUrl="uploadedCertificateUrl"
        :skillModel="editingSkillModel"
        :tmId="tmModel.Id"
        @cancel="closeEdit()"
        :skillList="skillList"
        :loading="loading"
      />
    </v-dialog>
  </v-card>
</template>
<script lang="ts">
import { TeammemberSkill } from "../../../models/Teammember";
import { defineComponent } from "vue";
import CoreSkill from "../../../models/CoreSkill";
import AddOrEditSkill from "./AddOrEditSkill.vue";
import { ProjectMessages } from "../../../definitions/constants";
import { Profile } from "../../../definitions/config";
import ConfirmDialog from "../../ConfirmDialog.vue";
import AutoCompleteField from "../../Fields/AutoCompleteField.vue";
import ComboBoxField from "../../Fields/ComboBoxField.vue";
import InfoBox from "../../InfoBox.vue";
import SkillItem from "./SkillItem.vue";

export default defineComponent({
  props: [
    "skills",
    "teammemberSkills",
    "showEditSkillModal",
    "addSkillLoading",
    "removeSkillloading",
    "sendReqeustLoading",
    "uploadedCertificate",
    "isGettingAllSection",
    "tmModel",
    "saveRoleAndTitleLoading",
    "details",
    "isHiringmanager",
  ],
  components: {
    AddOrEditSkill,
    ConfirmDialog,
    ComboBoxField,
    AutoCompleteField,
    InfoBox,
    SkillItem,
  },
  data() {
    return {
      isGettingSkill: false,
      loading: false,
      experienceYearList: Profile.Members.SkillExperienceList,
      shouldRequest: true,
      skillList: [] as CoreSkill[],
      filteredSkills: [] as CoreSkill[],
      teammemberSkillModel: {} as TeammemberSkill,
      editingSkillModel: {} as TeammemberSkill,
      teammemberSkillList: [] as TeammemberSkill[],
      showLevel: false,
      showYear: false,
      showAddOrEdit: false,
      comboboxSkillString: "",
      requestLoading: false,
      uploadedCertificateUrl: "",
      showSave: false,
      selectedSkill: null as CoreSkill | null,
      selectedJobRoles: null,
      selectedJobTitle: null,
      selectedSkillLevel: "",
      selectedTotalExperienceYear: "0",
      showJobRequestConfirm: false,
      sendReqeustLoadingProgress: false,
      headers: [
        { sortable: false, title: "Skill", value: "SkillId" },
        { sortable: false, title: "Favorite skill", value: "IsTopSkill", align: "center" },
        { sortable: false, title: "Level", value: "Level" },
        { sortable: false, title: "Total years", value: "TotalExperienceYears", align: "center" },
        { sortable: false, title: "Certificate", value: "Certificate", align: "center" },
        { sortable: false, title: "Assessment", value: "Assessment", align: "center" },
        { sortable: false, title: "Actions", value: "Actions" },
      ],
      rules: {
        required: (value: any) => !!value || "Required.",
      },
      confirmModel: {
        title: ProjectMessages.removeCareerHistory,
        text: ProjectMessages.confirmation,
      },
    };
  },
  methods: {
    showAddSkill() {
      this.showAddOrEdit = true;
      this.$emit("showEditSkill");
    },
    async saveRoleAndTitle() {
      var isValid = (await (this.$refs.frmMain as any).validate()).valid;
      if (isValid) {
        this.$emit("saveRoleAndTitle", { Roles: this.selectedJobRoles, Title: this.selectedJobTitle });
      }
    },
    cancelSending(): void {
      this.showJobRequestConfirm = false;
    },
    async confirmSendJobRequest(selectedJob: any) {
      this.sendReqeustLoadingProgress = true;
      this.sendReqeustLoadingProgress = false;
      this.showJobRequestConfirm = false;
    },
    sendTitleRequest() {
      this.confirmModel.title = "Sending request to add a Job Title";
      this.confirmModel.text = "Are you sure you want to send request to admin to add This?";
      this.showJobRequestConfirm = true;
    },
    islimited(isTopSkill: any) {
      var res = false;
      var findTopSkills = this.teammemberSkillList.filter((c) => c.IsTopSkill);
      if (findTopSkills && findTopSkills.length >= Profile.Members.FavoriteSkillLimit && !isTopSkill) {
        res = true;
      }
      return res;
    },
    changeSkillStatus(item: TeammemberSkill) {
      var findTopSkills = this.teammemberSkillList.filter((c) => c.IsTopSkill);
      if (item.IsTopSkill) {
        if (findTopSkills && findTopSkills.length >= Profile.Members.FavoriteSkillLimit) {
          this.$emit("showLimitationMessage", ProjectMessages.favortieSkillLimitation);
          this.saveSkill(item);
        } else if (findTopSkills && findTopSkills.length > Profile.Members.FavoriteSkillLimit) {
          this.$emit("showLimitationMessage", ProjectMessages.usedFavoriteSkillLimitation);
        } else {
          this.saveSkill(item);
        }
      } else {
        this.saveSkill(item);
      }
    },
    skillDownload(certificateUrl: any) {
      this.$emit("skillDownload", certificateUrl);
    },
    skillCertificateChanged(skill: any) {
      this.$emit("skillCertificateChanged", skill);
    },
    remove(item: any) {
      this.$emit("remove", item);
    },
    edit(item: any) {
      this.editingSkillModel = { ...item };
      this.$emit("showEditSkill");
    },
    getSkillName(skillId: any) {
      var skill = this.skillList.find((c) => c.id === skillId);
      if (skill) {
        return skill.Text;
      }
    },
    resetSkillForm() {
      this.showLevel = false;
      this.showSave = false;
      this.selectedSkillLevel = "";
      this.selectedTotalExperienceYear = "0";
    },
    closeEdit() {
      this.editingSkillModel = {} as TeammemberSkill;
      this.showAddOrEdit = false;
      this.$emit("closeEditModal");
    },
    addSkill() {
      this.showSave = true;
      if (this.teammemberSkillModel.Level && this.teammemberSkillModel.TotalExperienceYears > 0 && this.teammemberSkillModel.SkillId) {
        var skillModel = { ...this.teammemberSkillModel };
        this.saveSkill(skillModel);
        this.selectedSkill = null;
        this.resetSkillForm();
      } else if (this.isGettingSkill) {
        this.$emit("saveSkill");
      }
    },
    fillSkill(item: any) {
      if (item) {
        this.comboboxSkillString = item.Text ? item.Text : item;
      }
    },
    saveSkill(item: TeammemberSkill) {
      this.$emit("saveSkill", item);
    },
    convertTopSkill(val: any) {
      return val;
    },
  },
  watch: {
    comboboxSkillString(newVal) {
      if (!newVal) {
        this.resetSkillForm();
      } else {
        this.showSave = true;
        var findSkill = this.skillList.find((c) => c && c.Text.trim().toLowerCase() === newVal.trim().toLowerCase());
        if (findSkill) {
          this.teammemberSkillModel.SkillId = findSkill.id;
        } else {
          this.teammemberSkillModel.SkillId = newVal;
        }
        this.showLevel = true;
      }
    },
    isGettingAllSection(newVal) {
      this.isGettingSkill = newVal;
      if (newVal) {
        this.addSkill();
      }
    },
    uploadedCertificate(newVal) {
      this.uploadedCertificateUrl = newVal;
    },
    sendReqeustLoading(newVal) {
      this.requestLoading = newVal;
    },
    addSkillLoading(newVal) {
      this.loading = newVal;
    },
    removeSkillloading(newVal) {
      this.loading = newVal;
    },
    showEditSkillModal(newVal) {
      this.showAddOrEdit = newVal;
      if (!newVal) {
        this.editingSkillModel = {} as TeammemberSkill;
      }
    },
    teammemberSkills(newVal) {
      this.teammemberSkillList = newVal;
      this.teammemberSkillList.forEach((item) => {
        item.IsTopSkill = this.convertTopSkill(item.IsTopSkill);
      });
      this.loading = false;
    },
    skills(newVal) {
      this.skillList = newVal;
    },
  },
  mounted() {
    this.$emit("getSkills");
    this.selectedJobRoles = this.tmModel?.SpecificRoles;
    this.selectedJobTitle = this.tmModel?.SpecificTitle;
    this.skillList = this.skills;
    this.teammemberSkillList = this.teammemberSkills;
    this.teammemberSkillList.forEach((item) => {
      item.IsTopSkill = this.convertTopSkill(item.IsTopSkill);
    });
  },
});
</script>
